
import { defineComponent, onBeforeMount, onMounted, reactive } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

import { InvoiceT } from '@/core/types/orders.types'

import { orders } from '@/core/realisations/orders.realisation'

import useNotifications from '@/common/composable/useNotifications'
import { useRoute } from 'vue-router'

export default defineComponent({
    components: {
        TheButton,
        Loader,
    },
    setup() {
        const notifications = useNotifications()
        const route = useRoute()

        const invoice_id = Number(route.params.invoice_id)
        
        const state = reactive({
            is_loading: false,
            is_failed: false,
            invoice: null as InvoiceT | null
        })

        const loadInvoice = async () => {
            try {
                state.is_loading = true

                const response = await orders.getInvoice(invoice_id)
                state.invoice = response.data

                setTimeout(window.print, 1000)
                
                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({ title: 'При получении накладной произошла ошибка', error })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadInvoice)

        return { state, loadInvoice }
    },
})
